module.exports = __webpack_public_path__ + "assets/img/186101.c539d6b2.png";